import { ScaleBalanceIcon } from './ScaleBalanceIcon';

/**
 * author: Simran
 * id 82048BA4-F949-4572-B59B-23197F9B36D6
 * name scale-balance
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/scale-balance.svg
 * tags
 * - Science 
 */
export const JusticeIcon = ScaleBalanceIcon;
export default JusticeIcon